const locales = [
  {
    code: 'ca-AD',
    name: 'Català (Andorra)'
  },
  {
    code: 'ca-ES',
    name: 'Català'
  },
  {
    code: 'es-AR',
    name: 'Español (Argentina)'
  },
  {
    code: 'es-CL',
    name: 'Español (Chile)'
  },
  {
    code: 'es-CO',
    name: 'Español (Colombia)'
  },
  {
    code: 'es-ES',
    name: 'Español (España)'
  },
  {
    code: 'es-MX',
    name: 'Español (México)'
  },
  {
    code: 'en-US',
    name: 'English'
  },
  {
    code: 'eu-ES',
    name: 'Euskara'
  },
  {
    code: 'it-IT',
    name: 'Italiano'
  }
]

const codes = locales.map(item => item.code)
const defaultLocale = {
  code: 'en-US',
  name: 'English'
}

const parseLocale = someString => {
  const normalized = someString.toLowerCase().replace('_', '-')
  return locales.filter(item => item.code.toLowerCase().startsWith(normalized))[0]
}

export default {
  locales,
  codes,
  parseLocale,
  defaultLocale
}
